import { notification } from 'antd'
import jwt_decode from 'jwt-decode'
import swal from 'sweetalert'
import { privateAPI } from '../../config/constants'
import { decrypt, gettokenData } from '../../functions/globalFunctions'
import * as generalTypes from '../types/generalTypes'
import * as vendorTypes from '../types/vendorTypes'

let tokenData
if (localStorage.getItem('token')) {
  let token = jwt_decode(localStorage.getItem('token'))
  tokenData = decrypt(token.data)
}

export const getOfflineStats = (payload) => {
  return async () => {
    let data = {
      ...payload,
    }

    const res = await privateAPI.post(`/offline/get-stats`, { data })

    if (res) {
      return decrypt(res.data)
    }
  }
}

export const totalRegisteredCustomersNumber = () => {
  return async () => {
    const res = await privateAPI.post(`/offline/get-total-registered-customers-number`)
    if (res) {
      // setTotalRegistered(decrypt(res.data))
      return decrypt(res.data)
    }
  }
}

export const getCurrentMonthCustomersNumber = () => {
  return async () => {
    const res = await privateAPI.post(`/offline/get-current-month-customers-number`)
    if (res) {
      // setTotalRegistered(decrypt(res.data))
      return decrypt(res.data)
    }
  }
}

export const registeredUserStat = () => {
  return async () => {
    const res = await privateAPI.post(`/offline/get-registered-month-users`)
    if (res) {
      return decrypt(res.data)
    }
  }
}

export const getRepeatedCustomers = () => {
  return async () => {
    const res = await privateAPI.post(`/offline/get-repeated-customers`)
    if (res) {
      return decrypt(res.data)
    }
  }
}

export const getYesterdayCustomersNumber = ({ date }) => {
  return async () => {
    const res = await privateAPI.post(`/offline/get-yesterday-customers-number`, {
      data: { date },
    })
    if (res) {
      return decrypt(res.data)
    }
  }
}

export const getLast30DaysCustomersNumber = ({ date }) => {
  return async () => {
    const res = await privateAPI.post(`/offline/get-last-30days-customers-number`, {
      data: { date },
    })
    if (res) {
      return decrypt(res.data)
    }
  }
}

export const getAllCustomersOffline = (page, payload) => {
  return async (dispatch) => {
    let data = { ...payload, page }

    const res = await privateAPI.post(`/offline/get-offline-customers`, { data: data })
    if (res) {
      const resp = decrypt(res.data)

      dispatch({
        type: generalTypes.GET_TOTAL_PAGES,
        payload: resp.totalDocs,
      })
      dispatch({
        type: vendorTypes.GET_ALL_CUSTOMERS_OFFLINE,
        payload: resp.users,
      })
    }
  }
}

export const getAllCustomersOfflineMobiles = (payload) => {
  return async (dispatch) => {
    let data = {
      ...payload,
    }

    const res = await privateAPI.post(`/offline/get-offline-customers-mobiles`, { data })
    if (res) {
      const resp = decrypt(res.data)
      dispatch({
        type: vendorTypes.GET_DISTINCT_MOBILE_ID_FOR_CAMPAIGN,
        payload: resp.allMobiles,
      })
    }
  }
}

export const searchOfflineCustomers = (page, payload) => {
  return async (dispatch) => {
    let data = {
      ...payload,
    }
    const res = await privateAPI.post(
      `/offline/search-offline-customers/${tokenData?.vendorId}/${payload.tabName}?page=${page}`,
      { data: data },
    )
    if (res) {
      let resp = decrypt(res.data)
      dispatch({
        type: vendorTypes.GET_DISTINCT_MOBILE_ID_FOR_CAMPAIGN,
        payload: resp.mobiles,
      })
      dispatch({
        type: generalTypes.GET_TOTAL_PAGES,
        payload: resp.totalDocs,
      })
      dispatch({
        type: vendorTypes.GET_ALL_CUSTOMERS_OFFLINE,
        payload: resp.users,
      })
    }
  }
}

export const advanceSearchOffline = (page, payload) => {
  return async (dispatch) => {
    let data = { ...payload }
    dispatch({
      type: vendorTypes.GET_ALL_CUSTOMERS_OFFLINE,
      payload: null,
    })

    const res = await privateAPI.post(`/offline/advance-search?page=${page}`, {
      data,
    })
    if (res) {
      let resp = decrypt(res.data)
      console.log('🚀 ~ file: vendorActions.js:166 ~ return ~ resp:', resp)
      dispatch({
        type: vendorTypes.GET_DISTINCT_MOBILE_ID_FOR_CAMPAIGN,
        payload: resp.allMobiles,
      })
      dispatch({
        type: generalTypes.GET_TOTAL_PAGES,
        payload: resp.totalDocs,
      })
      dispatch({
        type: vendorTypes.GET_ALL_CUSTOMERS_OFFLINE,
        payload: resp.users,
      })
    }
  }
}

export const getOnlineStats = (payload) => {
  return async () => {
    let data = { ...payload }

    const res = await privateAPI.post(
      `/online/get-stats/${tokenData?.vendorId}/${payload.tabName}`,
      { data },
    )
    if (res) {
      return decrypt(res.data)
    }
  }
}

export const getAllCustomers = (page, payload) => {
  return async (dispatch) => {
    let data = { ...payload }

    const res = await privateAPI.post(
      `/online/get-customers/${tokenData?.vendorId}/${payload.tabName}?page=${page}`,
      { data },
    )
    if (res) {
      let resp = decrypt(res.data)

      dispatch({
        type: generalTypes.GET_TOTAL_PAGES,
        payload: resp.totalDocs,
      })
      dispatch({
        type: vendorTypes.GET_ALL_CUSTOMERS,
        payload: resp.users,
      })
      dispatch({
        type: vendorTypes.GET_DISTINCT_MOBILE_ID_FOR_CAMPAIGN,
        payload: resp.allMobiles,
      })
    }
  }
}

export const vendorLoyalties = (page, loyaltyPoint) => {
  return async (dispatch) => {
    let vendorId = gettokenData()?.vendorId
    const res = await privateAPI.post(`/offline/vendor-loyalty/${vendorId}?page=${page}`, {
      data: { loyaltyPoint },
    })
    if (res) {
      let resp = decrypt(res.data)
      console.log('🚀 ~ return ~ resp:', resp)
      dispatch({
        type: generalTypes.GET_TOTAL_PAGES_LOYALTY,
        payload: resp.totalDocs,
      })
      return resp?.result
    }
  }
}

export const vendorLoyaltiesFilter = (payload) => {
  // return async (dispatch) => {
  return async () => {
    // console.log("kdsjkdjfkjgf", payload)
    let vendorId = gettokenData()?.vendorId
    const res = await privateAPI.post(`/offline/vendor-loyalty-filters/${vendorId}`, {
      data: payload,
    })
    // console.log("response====================>", res)
    if (res) {
      // let resp = decrypt(res.data)
      let resp = res.data

      // console.log("respo", resp?.result)
      // dispatch({
      //   type: generalTypes.GET_TOTAL_PAGES_LOYALTY,
      //   payload: resp.totalDocs,
      // })
      return resp
    }
  }
}

export const levisLoyaltiesFilter = (payload) => {
  // return async (dispatch) => {
  return async () => {
    // console.log("kdsjkdjfkjgf", payload)
    let vendorId = gettokenData()?.vendorId
    const res = await privateAPI.post(`/offline/levis-loyalty-filters/${vendorId}`, {
      data: payload,
    })
    // console.log("response====================>", res)
    if (res) {
      // let resp = decrypt(res.data)
      let resp = res.data

      // console.log("respo", resp?.result)
      // dispatch({
      //   type: generalTypes.GET_TOTAL_PAGES_LOYALTY,
      //   payload: resp.totalDocs,
      // })
      return resp
    }
  }
}

export const vendorLoyaltyByInvoice = async (page, mobile) => {
  const res = await privateAPI.post(`/offline/vendor-loyalty-by-invoice`, {
    data: { page, mobile },
  })
  if (res) {
    let resp = decrypt(res.data)
    return resp?.result
  }
}

export const searchOnlineCustomers = (page, payload) => {
  return async (dispatch) => {
    let data = { ...payload }

    const res = await privateAPI.post(
      `/online/search-online-customers/${tokenData?.vendorId}/${payload.tabName}?page=${page}`,
      { data },
    )

    if (res) {
      let resp = decrypt(res.data)
      dispatch({
        type: vendorTypes.GET_DISTINCT_MOBILE_ID_FOR_CAMPAIGN,
        payload: resp.mobiles,
      })
      dispatch({
        type: generalTypes.GET_TOTAL_PAGES,
        payload: resp.totalDocs,
      })
      dispatch({
        type: vendorTypes.GET_ALL_CUSTOMERS,
        payload: resp.users,
      })
    }
  }
}

export const advanceSearchOnline = (page, payload) => {
  return async (dispatch) => {
    let data = { ...payload }
    dispatch({
      type: vendorTypes.GET_ALL_CUSTOMERS,
      payload: null,
    })

    const res = await privateAPI.post(`/online/advance-search?page=${page}`, {
      data,
    })
    if (res) {
      let resp = decrypt(res.data)
      dispatch({
        type: vendorTypes.GET_DISTINCT_MOBILE_ID_FOR_CAMPAIGN,
        payload: resp.allMobiles,
      })

      dispatch({
        type: generalTypes.GET_TOTAL_PAGES,
        payload: resp.totalDocs,
      })
      dispatch({
        type: vendorTypes.GET_ALL_CUSTOMERS,
        payload: resp.users,
      })
    }
  }
}

export const getVendorCampaigns = (mode) => {
  return async (dispatch) => {
    try {
      const res = await privateAPI.get(
        `/campaign/get-vendor-users-for-campaign/${tokenData?.vendorId}/${mode}`,
      )
      if (res) {
        let resp = decrypt(res.data)
        dispatch({
          type: vendorTypes.GET_VENDOR_CAMPAIGNS,
          payload: resp?.Result?.usersPredictions,
        })
      }
    } catch (error) {
      swal('', error?.response?.data?.message || 'Server Error', 'error')
    }
  }
}

export const userCurrentLoyalty = (userId) => {
  return async () => {
    const res = await privateAPI.post(`/general/user-current-loyalty`, {
      data: {
        userId,
      },
    })
    if (res) {
      let resp = decrypt(res.data)
      return resp?.currentLoyalty ? String(resp?.currentLoyalty) : '-'
    }
  }
}

export const exportCustomerCsv = (payload) => {
  return async () => {
    const res = await privateAPI.post(`/offline/create-customer-csv`, {
      data: {
        Data: payload,
      },
    })
    if (res) {
      let response = decrypt(res.data)

      const link = document.createElement('a')
      link.download = `customers.csv`
      link.href = response.url
      document.body.appendChild(link)
      link.click()

      notification.success({
        message: response.message,
        description: 'Your File will be downloaded shortly',
        duration: 10,
      })

      // return decrypt(res.data);
    }
  }
}

// export const getAllRepeatedCustomers = (page) => {
//   return async (dispatch) => {
//     const id = localStorage.getItem("vendorId");
//     // old api end point
//     // const res = await privateAPI.get(`${url}/get-all-customers/${id}`);
//     const res = await privateAPI.get(
//       `${url}/new/get-online-customers-repeated/${id}?page=${page}`
//     );
//     if (res) {
//
//       dispatch({
//         type: generalTypes.GET_TOTAL_PAGES,
//         payload: res.data.totalDocs,
//       });
//       dispatch({
//         type: vendorTypes.GET_ALL_CUSTOMERS,
//         payload: res.data.users,
//       });
//       // return res.data.users;
//     }
//   };
// };
// export const getCustomCustomers = (page, date, type) => {
//   return async (dispatch) => {
//     const id = localStorage.getItem("vendorId");

//     const res = await privateAPI.post(
//       `${url}/new/get-customDate-customers-online?page=${page}`,
//       {
//         vendorId: id,
//         date,
//         type,
//         // date: "2020-08-31T06:14:00.000Z",
//       }
//     );
//     // const res = await privateAPI.get(`${url}/get-all-customers/89`);

//     if (res) {
//       dispatch({
//         type: generalTypes.GET_TOTAL_PAGES,
//         payload: res.data.totalDocs,
//       });
//       dispatch({
//         type: vendorTypes.GET_ALL_CUSTOMERS,
//         payload: res.data.users,
//       });
//       // return res.data.users;
//     }
//   };
// };

// NOT USING THESE APIS

// export const searchCustomerByNumber = (number) => {
//   return async (dispatch) => {
//
//     const id = localStorage.getItem("vendorId");
//     const res = await privateAPI.post(`${url}/search-number`, {
//       vendorId: id,
//       number,
//     });
//     if (res) {
//
//       // dispatch({
//       //   type: vendorTypes.GET_ALL_CUSTOMERS_OFFLINE,
//       //   payload: res.data,
//       // });
//       // return res.data;
//     }
//   };
// };

// export const getCustomCustomersOffline = (date, type) => {
//   return async (dispatch) => {
//     const id = localStorage.getItem("vendorId");

//     const res = await privateAPI.post(`${url}/get-customDate-customers-offline`, {
//       vendorId: id,
//       date,
//       type,
//       // date: "2020-08-31T06:14:00.000Z",
//     });
//     // const res = await privateAPI.get(`${url}/get-all-customers/89`);

//     if (res) {
//       // dispatch({
//       //   type: vendorTypes.GET_ALL_CUSTOMERS,
//       //   payload: res.data,
//       // });
//       return res.data;
//     }
//   };
// };

// export const getTotalCustomers = () => {
//   return async (dispatch) => {
//     const id = localStorage.getItem("vendorId");
//     const res = await privateAPI.get(`${url}/total-customers/${id}`);
//     if (res) {
//       dispatch({
//         type: vendorTypes.GET_TOTAL_CUSTOMERS,
//         payload: res.data.totalUsers,
//       });
//       return res.data.totalUsers;
//     }
//   };
// };

// export const getVendorPurchases = () => {
//   return async (dispatch) => {
//     const vendorId = localStorage.getItem("vendorId");
//     const res = await privateAPI.post(`${url}/discount-full-vendor`, {
//       vendorId,
//     });
//     if (res) {
//       dispatch({
//         type: vendorTypes.GET_VENDOR_PURCHASES,
//         payload: res.data,
//       });
//       return res.data;
//     }
//   };
// };

// export const getVendorProducts = () => {
//   return async (dispatch) => {
//     const id = localStorage.getItem("vendorId");

//     const res = await privateAPI.get(`${url}/get-vendor-sales/${id}`);
//     if (res) {
//       // dispatch({
//       //   type: vendorTypes.GET_ALL_CUSTOMERS,
//       //   payload: res.data,
//       // });
//       return res.data.TotalProducts;
//     }
//   };
// };

// export const getVendorProductsOffline = () => {
//   return async (dispatch) => {
//     const id = localStorage.getItem("vendorId");

//     const res = await privateAPI.get(`${url}/get-vendor-sales-offline/${id}`);

//     if (res) {
//       // dispatch({
//       //   type: vendorTypes.GET_ALL_CUSTOMERS,
//       //   payload: res.data,
//       // });
//       return res.data.TotalProducts;
//     }
//   };
// };
